import { createFileRoute } from "@tanstack/react-router";

import Report from "/src/routes/person/detail/report/Report";

export const Route = createFileRoute("/_main/person/$id/report")({
  component: Report,
});
